import { render } from "./OfflineIndicator.vue?vue&type=template&id=228426a6&scoped=true"
import script from "./OfflineIndicator.vue?vue&type=script&lang=js"
export * from "./OfflineIndicator.vue?vue&type=script&lang=js"

import "./OfflineIndicator.vue?vue&type=style&index=0&id=228426a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228426a6"]])

export default __exports__